/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Package_HintInputs */

const en_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call to set up a lesson package billing plan.`)
};

const es_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llama para configurar un plan de pagos de tu paquete de lecciones.`)
};

const de_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rufen Sie an, um einen Abrechnungsplan für das Unterrichtspaket einzurichten.`)
};

const zh_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`致电设置课程包计费计划。`)
};

const ar_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اتصل لإعداد خطة فوترة لباقة الدروس.`)
};

const fr_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appelez pour établir un plan de facturation du forfait de cours.`)
};

const vi_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gọi để thiết lập kế hoạch thanh toán gói bài học.`)
};

const sw_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piga simu ili kusanidi mpango wa bili wa kifurushi cha somo.`)
};

const th_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โทรเพื่อจัดทำแผนการชำระค่าแพ็คเกจบทเรียน`)
};

const bs_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazovite da dogovorite plan naplate paketa lekcija.`)
};

const ja_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンパッケージのお支払いプランはお電話でご相談ください。`)
};

const ko_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 패키지 결제 플랜을 설정하려면 전화해 주세요.`)
};

const pt_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligue para montar um plano de pagamento do pacote de aulas.`)
};

const it_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiamaci per impostare un piano di pagamento per il pacchetto di lezioni.`)
};

const sv_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ring för att ordna en betalningsplan för ett lektionspaket.`)
};

const nl_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bel om een betalingsplan voor een lespakket af te spreken.`)
};

const da_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ring for at aftale en betalingsplan for en lektionspakke.`)
};

const nb_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ring for å sette opp en betalingsplan for en timepakke.`)
};

const fi_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soita ja sovi tuntipaketin maksusuunnitelmasta.`)
};

const pl_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadzwoń, żeby przygotować plan rozliczania pakietów lekcji.`)
};

const ru_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позвоните, чтобы оформить план оплаты пакета уроков.`)
};

const tr_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir ders paketi fatura planı kurmak için arayın.`)
};

const hi_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लेसन पैकेज के लिए बिलिंग योजना तय करने हेतु कॉल करें।`)
};

const id_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telepon kami untuk mengatur rencana penagihan paket pelajaran.`)
};

const ms_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami untuk menetapkan pelan bayaran pakej pelajaran.`)
};

const cs_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zavolejte nám a domluvíme platební plán pro balíček lekcí.`)
};

const el_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καλέστε μας για να ορίσουμε πρόγραμμα πληρωμής για ένα πακέτο μαθημάτων.`)
};

const he_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התקשרו כדי לקבוע תוכנית תשלום לחבילת שיעורים.`)
};

const af_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bel om 'n faktuurplan vir 'n lespakket op te stel.`)
};

const hu_prices_package_hint = /** @type {(inputs: Prices_Package_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hívjon minket, és összeállítjuk az óracsomag fizetési tervét.`)
};

/**
* | output |
* | --- |
* | "Call to set up a lesson package billing plan." |
*
* @param {Prices_Package_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_package_hint = /** @type {((inputs?: Prices_Package_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Package_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_package_hint(inputs)
	if (locale === "de") return de_prices_package_hint(inputs)
	if (locale === "zh") return zh_prices_package_hint(inputs)
	if (locale === "ar") return ar_prices_package_hint(inputs)
	if (locale === "fr") return fr_prices_package_hint(inputs)
	if (locale === "vi") return vi_prices_package_hint(inputs)
	if (locale === "sw") return sw_prices_package_hint(inputs)
	if (locale === "th") return th_prices_package_hint(inputs)
	if (locale === "bs") return bs_prices_package_hint(inputs)
	if (locale === "ja") return ja_prices_package_hint(inputs)
	if (locale === "ko") return ko_prices_package_hint(inputs)
	if (locale === "pt") return pt_prices_package_hint(inputs)
	if (locale === "it") return it_prices_package_hint(inputs)
	if (locale === "sv") return sv_prices_package_hint(inputs)
	if (locale === "nl") return nl_prices_package_hint(inputs)
	if (locale === "da") return da_prices_package_hint(inputs)
	if (locale === "nb") return nb_prices_package_hint(inputs)
	if (locale === "fi") return fi_prices_package_hint(inputs)
	if (locale === "pl") return pl_prices_package_hint(inputs)
	if (locale === "ru") return ru_prices_package_hint(inputs)
	if (locale === "tr") return tr_prices_package_hint(inputs)
	if (locale === "hi") return hi_prices_package_hint(inputs)
	if (locale === "id") return id_prices_package_hint(inputs)
	if (locale === "ms") return ms_prices_package_hint(inputs)
	if (locale === "cs") return cs_prices_package_hint(inputs)
	if (locale === "el") return el_prices_package_hint(inputs)
	if (locale === "he") return he_prices_package_hint(inputs)
	if (locale === "af") return af_prices_package_hint(inputs)
	if (locale === "hu") return hu_prices_package_hint(inputs)
	return en_prices_package_hint(inputs)
});